/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { forwardRef, memo, useImperativeHandle, useMemo, useRef } from 'react';
import { boxBorder, overflowHidden, parseHeight, pd, pointerEventsNone, positionRelative, textColor, userSelectNone } from "../../styles/general";
import { useTheme } from "../../theme";
import { classNames } from "../../utils";
const {
  typography: {
    paragraph1
  }
} = useTheme();
const AccordionDetails = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  action = {},
  children,
  className,
  id,
  style
}, reference) => {
  if (!reference) reference = useRef(null);
  const ref = useRef(null);
  useImperativeHandle(reference, () => {
    const currentRef = ref.current || {};
    currentRef.element = ref.current;
    const _instance = {
      ...action
    }; // methods
    _instance.__proto__ = {}; // hidden methods
    currentRef.instance = _instance;
    return currentRef;
  });
  return useMemo(() => {
    return jsx("div", {
      css: DetailsRootCSS,
      className: 'DGN-UI-Accordion-Details',
      ref: ref,
      id: id
    }, jsx("div", {
      style: style,
      className: classNames('DGN-UI-Accordion-Details-Content', className)
    }, children));
  }, [children, className, id, style]);
}));
const DetailsRootCSS = css`
    ${positionRelative};
    ${overflowHidden};
    ${parseHeight(0)};
    transition: height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    .DGN-UI-Accordion-Details-Content {
        ${boxBorder};
        ${paragraph1};
        ${pd([0, 6, 4, 6])};
        ${textColor('text/main')};
        &.disabled {
            ${pointerEventsNone};
            ${userSelectNone};
        }
    }
`;
AccordionDetails.defaultProps = {
  className: '',
  id: '',
  style: {}
};
AccordionDetails.propTypes = {
  /** The content of the component. */
  children: PropTypes.node,
  /** Class for component. */
  className: PropTypes.string,
  /** Style inline of component. */
  style: PropTypes.object
};
export default AccordionDetails;